import { Navigate } from 'react-router-dom';
import { AuthorisationError } from '@/app/ui/AuthorisationError';
import { Login, Register, RegisterSuccess } from '@/pages/authentication';
import { Dashboard } from '@/pages/dashboard';
import { Discover } from '@/pages/discover';
import { NotFoundPage } from '@/pages/not-found';
import { OrganizationPage } from '@/pages/organization';
import { OrganizationInvitation } from '@/pages/organization-invitation';
import { OrganizationProcsPage } from '@/pages/organization-procs';
import { ProcPage } from '@/pages/proc';
import {
  MyProcInstancePage,
  ProcInstancePublicPage,
  UserProcInstancePage,
} from '@/pages/proc-instance';
import { ProcInstancesPage } from '@/pages/proc-instances';
import { ProcPreviewPage } from '@/pages/proc-preview';
import { Profile } from '@/pages/profile';
import { WorkspaceInvitation } from '@/pages/workspace-invitation';
import { useRoutes } from '../hooks';

const routes = [
  // Private routes
  { isPrivate: true, path: '/dashboard', element: <Dashboard /> },
  {
    isPrivate: true,
    path: '/dashboard/workspaces/:workspaceId',
    element: <Dashboard />,
  },
  {
    isPrivate: true,
    path: '/dashboard/knowledge-base',
    element: <Dashboard />,
  },
  {
    isPrivate: true,
    path: '/dashboard/my-instances',
    element: <Dashboard />,
  },
  { isPrivate: true, path: '/dashboard/discover', element: <Dashboard /> },
  {
    isPrivate: true,
    path: '/dashboard/discover/:code',
    element: <OrganizationProcsPage />,
  },
  {
    isPrivate: true,
    path: '/dashboard/discover/organization/:organizationId',
    element: <Dashboard />,
  },
  {
    isPrivate: true,
    path: '/dashboard/discover/organization',
    element: <Navigate to="/dashboard" />,
  },
  {
    isPrivate: true,
    path: '/dashboard/proc/:procId/preview',
    element: <ProcPreviewPage />,
  },
  {
    isPrivate: true,
    path: '/dashboard/author/proc/:procId',
    element: <ProcPage />,
  },
  {
    isPrivate: true,
    path: '/dashboard/author/proc/:procId/instances',
    element: <ProcInstancesPage />,
  },
  {
    isPrivate: true,
    path: '/dashboard/author/proc/instance/:procId',
    element: <UserProcInstancePage />,
  },
  {
    isPrivate: true,
    path: '/dashboard/proc/instance/:procId',
    element: <MyProcInstancePage />,
  },
  {
    isPrivate: true,
    path: '/dashboard/organization',
    element: <OrganizationPage />,
  },
  { isPrivate: true, path: '/dashboard/profile', element: <Profile /> },
  {
    isPrivate: true,
    path: '/dashboard/organization/invitation/:token',
    element: <OrganizationInvitation />,
  },
  {
    isPrivate: true,
    path: '/dashboard/invitation/:token',
    element: <WorkspaceInvitation />,
  },
  {
    isPrivate: true,
    path: '/dashboard/404',
    element: <NotFoundPage />,
  },
  {
    isPrivate: true,
    path: '/dashboard/*',
    element: <Navigate to="/dashboard" />,
  },

  // Public routes
  { path: '/', element: <Navigate to="/login" /> },
  { path: '/organization/:organizationId', element: <Discover /> },
  { path: '/login', element: <Login /> },
  { path: '/signup', element: <Register /> },
  { path: '/signup/thank-you', element: <RegisterSuccess /> },
  { path: '/procs/:procId/preview', element: <ProcPreviewPage /> },
  { path: '/procs/:procId/:code', element: <ProcInstancePublicPage /> },
  { path: '/discover/:code', element: <OrganizationProcsPage /> },
  { path: '/404', element: <NotFoundPage /> },
  { path: '/authorisation-error', element: <AuthorisationError /> },
  { path: '/*', element: <Navigate to="/" /> },
];

export const Routes = () => {
  return useRoutes(routes);
};
